/***
 * @Author: hippo
 * @Date: 2024-01-15 10:54:37
 * @LastEditors: hippo
 * @LastEditTime: 2024-12-27 15:51:10
 * @Description: 
 * @
 */
import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('referrals')

export const FETCH_LIST = createType('FETCH_LIST')
export const FETCH_RETAIL_LIST = createType('FETCH_RETAIL_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const SHOW_INVT_DIALOG = createType('SHOW_INVT_DIALOG')
export const HIDE_INVT_DIALOG = createType('HIDE_INVT_DIALOG')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const SET_ACTIVE_STATE = createType('SET_ACTIVE_STATE')
export const UPDATED = createType('UPDATED')
export const SHOW_LINK_LIST_DIALOG = createType('SHOW_LINK_LIST_DIALOG')
export const SHOW_MANAGER_LIST_DIALOG = createType('SHOW_MANAGER_LIST_DIALOG')
export const SHOW_RETAIL_LINK_LIST_DIALOG = createType('SHOW_RETAIL_LINK_LIST_DIALOG')
export const SHOW_RETAIL_MANAGER_LIST_DIALOG = createType('SHOW_RETAIL_MANAGER_LIST_DIALOG')
export const SHOW_BIND_DIALOG = createType('SHOW_BIND_DIALOG')
export const SHOW_RETAIL_BIND_DIALOG = createType('SHOW_RETAIL_BIND_DIALOG')
